import { ChangeDetectionStrategy, Component, input, viewChild } from "@angular/core";
import { FormControl, ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInput, MatInputModule } from "@angular/material/input";

import { provideNgValidators, provideNgValueAccessor } from "providers/cva-providers";
import { FormControlAccessor } from "utils/forms/form-control-accessor";

@Component({
  selector: "app-search-box",
  templateUrl: "./search-box.component.html",
  styleUrls: ["./search-box.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatButtonModule,
  ],
  providers: [
    provideNgValueAccessor(SearchBoxComponent),
    provideNgValidators(SearchBoxComponent),
  ],
})
export class SearchBoxComponent extends FormControlAccessor<string> {
  public readonly label = input<string | undefined>();
  public readonly placeholder = input<string>("");

  protected override formControl = new FormControl<string>("", { nonNullable: true });

  private readonly input = viewChild(MatInput);

  protected clearSearchQuery(): void {
    this.formControl.setValue("");
    this.focus();
  }

  public focus(): void {
    this.input()?.focus();
  }
}
